module.exports = __webpack_public_path__ + "img/3@2x.af30b316.png";